"use strict";

exports.__esModule = true;
exports.default = void 0;

var _loopStatus = _interopRequireDefault(require("../constants/loopStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRoundedLimit = function getRoundedLimit(limit, step) {
  var newValue = limit % step === 0 ? limit : Math.floor((limit + step) / step) * step;
  return newValue;
};

var loopAround = function loopAround(desiredInt, min, max, step) {
  if (desiredInt > max) {
    return {
      value: getRoundedLimit(min, step),
      status: _loopStatus.default.OVER
    };
  }

  if (desiredInt < min) {
    return {
      value: getRoundedLimit(max, step),
      status: _loopStatus.default.UNDER
    };
  }

  return {
    value: desiredInt,
    status: _loopStatus.default.ASIS
  };
};

var _default = loopAround;
exports.default = _default;